import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSuspensivePoints = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "70%",
	height: "100%",
	viewBox: "0 0 80 80",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 22,
			cy: 40,
			r: 6
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 40,
			cy: 40,
			r: 6
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 58,
			cy: 40,
			r: 6
		})
	]
});
const ForwardRef = forwardRef(SvgSuspensivePoints);
export { ForwardRef as ReactComponent };
